<dx-popup
  #popup
  [fullScreen]="true"
  [showTitle]="false"
  [dragEnabled]="false"
  [hideOnOutsideClick]="false"
  [showCloseButton]="false"
  (onShown)="onPopupShown()"
>
  <div *dxTemplate="let data of 'content'">
    <div [hidden]="docType !== 'doc' || isLoading" #richContainer></div>

    @if (docType === 'pdf') {
      <ng2-pdfjs-viewer #pdfViewer [openFile]="false" [urlValidation]="false"></ng2-pdfjs-viewer>
    }

    @if (docType === 'image') {
      <dx-scroll-view [useNative]="true" [width]="'100%'" [height]="'100%'">
        <img [src]="imageSrc" />
      </dx-scroll-view>
    }

    @if (docType === 'text') {
      <dx-scroll-view [useNative]="true" [width]="'100%'" [height]="'100%'">
        <div [innerHtml]="textSrc"></div>
      </dx-scroll-view>
    }

    @if (docType === null) {
      <div>Dieses Format kann nicht angezeigt werden!</div>
    }

    @if (isLoading) {
      <div class="loading-panel">
        <dx-load-indicator height="40" width="40"></dx-load-indicator>
      </div>
    }
  </div>

  @if (isVorlage) {
    <dxi-popup-toolbar-item
      widget="dxButton"
      location="before"
      toolbar="bottom"
      [options]="{ text: 'Platzhalterliste', type: 'default', icon: 'info', stylingMode: 'contained', onClick: onClickPlatzhalterliste }"
    >
    </dxi-popup-toolbar-item>
  }

  <dxi-popup-toolbar-item location="center" toolbar="bottom">
    <div *dxTemplate>
      <strong>{{ currentDocName }}</strong>
    </div>
  </dxi-popup-toolbar-item>

  @if (documentSelectionItems.length > 1) {
    <dxi-popup-toolbar-item
      widget="dxDropDownButton"
      location="after"
      toolbar="bottom"
      [options]="{
        text: 'Dokument wechseln',
        icon: 'switch',
        items: documentSelectionItems,
        displayExpr: 'text',
        keyExpr: 'index',
        disabled: isLoading,
        dropDownOptions: { maxHeight: '50vh' },
        elementAttr: { class: 'document-switch-dropdown', 'aria-label': 'Dokument in der Vorschau wechseln' },
        onItemClick: onClickDocumentSelection,
      }"
    >
    </dxi-popup-toolbar-item>
  }

  <dxi-popup-toolbar-item
    widget="dxButton"
    location="after"
    toolbar="bottom"
    [options]="{
      elementAttr: { id: 'docXToolbarButton' },
      text: isReadOnly ? 'Schließen' : 'Abbrechen',
      type: 'default',
      stylingMode: 'contained',
      icon: 'remove',
      onClick: onClickClose,
    }"
  >
  </dxi-popup-toolbar-item>
</dx-popup>
